import { useMemo } from 'react';

import { useTenantFeatureMap } from './useTenantFeatureMap';

export const COMMERCE_FEATURE_KEY = 'commerce.runtime.enabled';
export const RESELLER_FEATURE_KEY = 'commerce.reseller.enabled';

export interface CommerceAccessState {
  featureMap?: Record<string, boolean>;
  featureTenantId?: string;
  commerceFeatureEnabled: boolean;
  resellerFeatureEnabled: boolean;
}

export function useCommerceAccess(): CommerceAccessState {
  const { featureMap, featureTenantId } = useTenantFeatureMap();

  return useMemo(
    () => ({
      featureMap,
      featureTenantId,
      commerceFeatureEnabled: !!featureMap?.[COMMERCE_FEATURE_KEY],
      resellerFeatureEnabled: !!featureMap?.[RESELLER_FEATURE_KEY],
    }),
    [featureMap, featureTenantId]
  );
}
